<div class="col-md-12 padding-left-0px padding-right-0px margin-left-15px" >

  <div class="row margin-left-0px" *ngIf="Data && Data.HasChildren">
    <div class="col-md-12 padding-left-0px padding-right-0px" *ngFor="let f of  Data.Children">
      <div  [ngSwitch]="f.Data.ValueType">
        <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'Bool'">
          <auto-gen-boolpv class="col-md-12 padding-left-0px padding-right-0px" [Data]="f" [field]="f.Data"  [mode]="mode">
          </auto-gen-boolpv>
        </div>
        <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'List'">
          <auto-gen-listpv class="col-md-12 padding-left-0px padding-right-0px" [Data]="f" [field]="f.Data" [mode]="mode">
          </auto-gen-listpv>
        </div>
        <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'Text'">
          <auto-gen-textpv class="col-md-12 padding-left-0px padding-right-0px" [field]="f.Data" [mode]="mode"></auto-gen-textpv>
        </div>
        <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'CVS'">
          <auto-gen-cvspv class="col-md-12 padding-left-0px padding-right-0px" [field]="f.Data" FormMode="View" [mode]="mode"></auto-gen-cvspv>
        </div>

        <div class="row margin-left-0px margin-right-0px" *ngSwitchCase="'Date'">
          <auto-gen-datepv class="col-md-12 padding-left-0px padding-right-0px" [field]="f.Data" [mode]="mode"></auto-gen-datepv>
        </div>

        <div class="row margin-right-0px margin-left-0px" *ngSwitchCase="'Grid'">
          <!--<label>AUTO GEN CHILDREN - GRID COMP:..............</label>-->
          <auto-gen-gridpv class="col-md-12 padding-left-0px padding-right-0px" [field]="f"></auto-gen-gridpv>
        </div>
      </div>

      </div>
  </div>
</div>
